export const environment = {
    production: false,
  serviceWorker: true,
    apiUrl: 'https://qabdapi.stockfinder.co.za/',
    wsUrl: "wss://qabdccs.stockfinder.co.za/v1/ws/connect",
    appUrl: "https://qabdweb.stockfinder.co.za/",
    whatsappSubscriptionNumber: '+15550525978',
    vapidPublicKey: 'BMddK7m1GJoT4vIAbCX2kurbe_xyIlox5mE0S6PbB2fl8NEaXOfWKPrnqHSCQq_BDxmae1epJggi5sTJzxS7V1U'

};
